
import { Component, Prop, Vue } from 'vue-property-decorator';
import { tableHeaderProject } from '@/types/tableHeader';
import { STAT } from '@/config/config';
@Component
export default class CommonTableHead extends Vue {
  // 传递的是展示的数组
  @Prop() private list!: tableHeaderProject[];
  // 埋点
  @Prop() private stat!: string;
  // 特殊标签处理
  spanClick(item: tableHeaderProject, index: number) {
    if (item.type === 'rank') {
      // 不同页面埋点
      const stat = this.$route.name === 'rank' ? STAT.rank : STAT.homeRecommend;
      item.stat && window.hxmClickStat(`${stat}.${this.stat}.${item.stat}`);
      // 排序处理
      this.$emit('sort-click', index);
    } else {
      // 弹窗处理
      this.$emit('span-click', index);
    }
  }
}
